import { render, staticRenderFns } from "./MerchantOffMobile.vue?vue&type=template&id=39184b2f&scoped=true"
import script from "./MerchantOffMobile.vue?vue&type=script&lang=js"
export * from "./MerchantOffMobile.vue?vue&type=script&lang=js"
import style0 from "./MerchantOffMobile.vue?vue&type=style&index=0&id=39184b2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39184b2f",
  null
  
)

export default component.exports